import WKT from 'ol/format/WKT';
import { Map } from 'ol';

/**
 * Zooms the map to fit the extent of a geometry specified by WKT string.
 * Uses extent-based zoom with padding to show the entire geometry.
 * 
 * @param map - OpenLayers map instance
 * @param wkt - WKT string of the geometry
 * @param options - Optional configuration for zoom behavior
 * @returns true if successful, false if failed
 */
export function zoomToGeometryExtent(
  map: Map | null,
  wkt: string | null | undefined,
  options?: {
    padding?: [number, number, number, number];
    maxZoom?: number;
    duration?: number;
  }
): boolean {
  if (!map || !wkt) {
    return false;
  }

  const {
    padding = [100, 100, 100, 100],
    maxZoom = 18,
    duration = 500
  } = options || {};

  try {
    const format = new WKT();
    const geometry = format.readGeometry(wkt, {
      dataProjection: 'EPSG:3067',
      featureProjection: 'EPSG:3857',
    });
    const extent = geometry.getExtent();
    
    //console.log('📍 Zoom to extent:', extent, 'Current zoom:', map.getView().getZoom());
    
    map.getView().fit(extent, {
      padding,
      maxZoom,
      duration
    });

    return true;
  } catch (error) {
    console.error('Error zooming to geometry extent:', error);
    return false;
  }
}
